/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Addons_TitleInputs */

const en_billing_addons_title = /** @type {(inputs: Billing_Addons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Need more this month?`)
};

const id_billing_addons_title = /** @type {(inputs: Billing_Addons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butuh lebih bulan ini?`)
};

/**
* | output |
* | --- |
* | "Need more this month?" |
*
* @param {Billing_Addons_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_addons_title = /** @type {((inputs?: Billing_Addons_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Addons_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_addons_title(inputs)
	return en_billing_addons_title(inputs)
});